import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'snakeToKebab',
    standalone: false
})
export class SnakeToKebabPipe implements PipeTransform {

    transform(value: string): string {
        return value.toLowerCase().replace(/_/g, '-');
    }
}
